import React, {useState,useContext,createContext,useEffect,useRef,}  from 'react'
import {Form,Button,Container,Card,Alert,Row,Col,Tabs,Tab,Modal,Navbar} from 'react-bootstrap'
import axios from 'axios'
import {UserContext} from './UserContext'
import AccountingData from './components/AccountingData'
import CatalogueData from './components/CatalogueData'
import Firms from './components/Firms'
import Exhibits from './components/Exhibits'
import Items from './components/Items'
import Finish from './components/Finish'
import B2b from './components/B2b'
import './tabs.css'
import {Redirect,useHistory,Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDiagramSuccessor } from '@fortawesome/free-solid-svg-icons'
import Thankyou from './components/Thankyou'
import logo from './HELEXPO.jpg'


export default function App() {


  const [accountingData,setAccountingData]=useState({})
  const [originalAccountingData,setOriginalAccountingData]=useState({})
  const [catalogueData,setCatalogueData]=useState({})
  const [activeTab,setActiveTab]=useState('accounting')

  const [emptyAccountingData,setEmptyAccountingData]=useState({
    CMNAME:'',
    CMTIN:'',
    DOY:'',
    PROFESSION:'',
    STREET:'',
    CMSTREETNUMBER:'',
    CMPOSTALCODE:'',
    COUNTRY:'',
    CITY:'',
    CONTACTID:'',
    HASDATA:'0',
    CMEMAIL:'',
    CMEMAIL2:'',
    CMPHONE1:''
  })

  const [countries,setCountries]=useState([])
  const [oikoi,setOikoi]=useState([])
  const [exhibits,setExhibits]=useState([])
  const [items,setItems]=useState([])
  const [exhibitionExhibits,setExhibitionExhibits]=useState([])
  const [exhibition,setExhibition]=useState({})
  const [exhibitions,setExhibitions]=useState([])
  const [exhibitionExhibitsLocal,setExhibitionExhibitsLocal]=useState([])
  const [regObj,setRegObj]=useState({})
  const [isLoadingContact,setIsLoadingContact]=useState(false)
  const [showOldProfileModal,setShowOldProfileModal]=useState(false)
  const [oldProfiles,setOldProfiles]=useState([])
  const [tempData,setTempData]=useState([])
  const [epimelitiria,setEpimelitiria]=useState([])



  useEffect(()=>{
    axios.get(process.env.REACT_APP_API+'countries').then(res=>{
      setCountries(res.data)
    })   

    axios.get(process.env.REACT_APP_API+'exhibitions/mysql').then(res=>{
      setExhibitions(res.data)
      //console.log(res.data)
    }) 

    axios.get(process.env.REACT_APP_API+'epimelitiria').then(res=>{
      setEpimelitiria(res.data)
      //console.log(res.data)
    })     
  },[])


  const sendForm=(IsTemp)=>{
    const checkedExhibits=exhibitionExhibits.filter(item=>item.Checked==1)
    const checkedItems=items.filter(xitem=>xitem.quantity>0)
    let RegDate1 = new Date()
    const REGDATE=RegDate1.toISOString().split('T')[0]
    const obj={
        ISTEMP:IsTemp,
        REGDATE,
        CMTIN:accountingData.CMTIN,
        EXCODE:exhibition.GLX_ExCode,
        ENAME:exhibition.EName,
        EMAIL:exhibition.email,
        ISNEW:accountingData.CONTACTID.trim().length>0 ? 0 : 1,
        originalAccountingData,
        accountingData,
        catalogueData,
        oikoi,
        exhibits:checkedExhibits,
        items:checkedItems
    }
    const strObj=(JSON.stringify(obj))
    //console.log(obj)


    
    axios.post(process.env.REACT_APP_API+'finish/mysql',obj)
    .then(res=>{
      if (IsTemp==1){
        alert('Η ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ ΕΓΙΝΕ ΜΕ ΕΠΙΤΥΧΙΑ! Την επόμενη φορά που θα ξαναεισάγτε το ΑΦΜ σας θα είναι διαθέσιμα τα στοιχεία που έχετε εισάγει.')
      }

      if (IsTemp==0){
        alert('Ευχαριστούμε για την εγγραφή // Thank you for your registration')
        //window.location.reload(false)
        setActiveTab('thankyou')
      }
    }).catch(err=>{
      alert("An error has occured, please try again")
    })         

}

  const loadexhibitionsItems=(excode)=>{
      axios.get(process.env.REACT_APP_API+'items/'+excode,{
        headers: {
            'Authorization': 'Bearer '+process.env.REACT_APP_TOKEN
        }            
      }).then(res=>{
          const theItems=res.data//.filter(item=>item.GXSTRINGFIELD7==1)
          setItems(theItems)
          //console.log(res.data)
      })
  }

  const handleClose=()=>{
    
  }

  const handleClose1=()=>{

  }

  const loadActivityExhibits=(aid)=>{
           axios.get(process.env.REACT_APP_API+'exhibits/'+aid,{
                headers: {
                    'Authorization': 'Bearer '+process.env.REACT_APP_TOKEN
                }            
            }).then(res1=>{
                if (res1.data.err!=0){

                  const allExhibits=exhibitionExhibits

                    allExhibits.forEach(item0=>{
                        
                        if (res1.data.filter(item1=>item1.ETA30CODE==item0.ETA30CODE).length>0){
                            item0.Checked=1
                        }
                    })
                    setExhibitionExhibits(allExhibits)
                    setExhibitionExhibitsLocal(allExhibits)                    
                    setExhibits(res1.data)    
                }
            })                 
  }

  const loadAllExhibits=(excode)=>{

    axios.get(process.env.REACT_APP_API+'exhibitionExhibits/'+excode,{
        headers: {
            'Authorization': 'Bearer '+process.env.REACT_APP_TOKEN
        }            
    }).then(res=>{
        res.data.forEach(item=>{
            item.Checked=0
        })

        setExhibitionExhibits(res.data)
        setExhibitionExhibitsLocal(res.data)
        

    })
}

const clearData=()=>{
  //setExhibition({})
  setItems([])
  setExhibits([])
  setExhibitionExhibits([])
  setCatalogueData({})
  setOldProfiles([])
  setAccountingData({})


}
  const checkVatNum=(vat)=>{
    //clearData()
    setIsLoadingContact(true)
    
    if (vat.length>5){
      axios.get(process.env.REACT_APP_API+'checkvat/'+vat+'/'+exhibition.GLX_ExCode,{
        headers: {
            'Authorization': 'Bearer '+process.env.REACT_APP_TOKEN
            }            
        }).then(res=>{

        if (res.data.err==0){
            //console.log(res.data.catalogueDataList)
            setIsLoadingContact(false)
            setAccountingData(res.data.accountingData)
            setOriginalAccountingData(res.data.accountingData)
            setOldProfiles(res.data.catalogueDataList) 
            setTempData(res.data.tempData) 
            if (res.data.catalogueDataList.length>0){
              setShowOldProfileModal(true)
            }

            //console.log(res.data.tempData)
        }else{
          setIsLoadingContact(false)
          setAccountingData({...emptyAccountingData,CMTIN:vat}) 
          setTempData(res.data.tempData) 
          //console.log(res.data.tempData)
        }
      })
    }else{
      setIsLoadingContact(false)
      setAccountingData({...emptyAccountingData,CMTIN:vat}) 
    }
  }

  //const oldProfilesList=oldProfiles.filter(ex=>exhibition.GLX_ExCode.split('-')[0]==ex.EXCODE.split('-')[0]).map((item,index)=>{
  const oldProfilesList=oldProfiles.map((item,index)=>{
    return(
      <option key={index} value={item.ACTIVITYID}>{item.EXHIBITIONNAME} // {item.CMSTRINGFIELD2}</option>
    )
  })

  const countriesList=countries.map((item,index)=>{
    return(
      <option key={index} value={item.GXDESCRIPTION}>{item.GXCODE} // {item.GXDESCRIPTION} // {item.GXDESCRIPTIONENG}</option>
    )
  })


  const countriesListGr=countries.map((item,index)=>{
    return(
      <option key={index} value={item.GXDESCRIPTION}>{item.GXDESCRIPTION}</option>
    )
  })

  const countriesListEng=countries.map((item,index)=>{
    return(
      <option key={index} value={item.GXDESCRIPTIONENG}>{item.GXDESCRIPTIONENG}</option>
    )
  })


  const exhibitionsList=exhibitions.map((item,index)=>{
    return(
      <option key={index} value={item.GLX_ExCode}>{item.EName}</option>
    )
  })

  const getProfile=(aid)=>{
    //console.log(oldProfiles.filter(item=>item.ACTIVITYID==aid))
    setCatalogueData(oldProfiles.filter(item=>item.ACTIVITYID==aid)[0])
    loadActivityExhibits(aid)
    setShowOldProfileModal(false)
  }

  const getExhibition=(eid)=>{

    if (eid.length>0){
      setExhibition(exhibitions.filter(i=>i.GLX_ExCode==eid)[0]) 
      //console.log(exhibitions.filter(i=>i.GLX_ExCode==eid)[0])
      loadAllExhibits(eid)
      loadexhibitionsItems(eid)
      //setShowOldProfileModal(true)
    }else{
      setExhibitionExhibits([])
      setExhibition({})
      setCatalogueData({})
      setOldProfiles([])
      setAccountingData({})
    } 
  }


  const temporarySave=()=>{
    const checkedExhibits=exhibitionExhibits.filter(item=>item.Checked==1)
    const checkedItems=items.filter(xitem=>xitem.quantity>0)
    const obj={
      CMTIN:accountingData.CMTIN,
      EXCODE:exhibition.GLX_ExCode,
      accountingData,
      catalogueData,
      oikoi,
      exhibits:checkedExhibits,
      items:checkedItems
    }
    const strObj=(JSON.stringify(obj))
    console.log(JSON.parse(strObj))
    setRegObj(obj)

  }



  const restoreTempData=()=>{
    setAccountingData(tempData.accountingData)
    setCatalogueData(tempData.catalogueData)
    setExhibits(tempData.exhibits)
    setOikoi(tempData.oikoi)

    const allExhibits=exhibitionExhibits

    allExhibits.forEach(item0=>{
        
        if (tempData.exhibits.filter(item1=>item1.ETA30CODE==item0.ETA30CODE).length>0){
            item0.Checked=1
        }
    })
    setExhibitionExhibits(allExhibits)    


   // alert("ΟΚ!")

  }

  return (
    <Container fluid>
    <Alert variant='light'>
    <h4>
    {exhibition.GLX_ExCode ? 
      <p align="center"><img width="100%" src={`${process.env.REACT_APP_BASEURL}exhibitionsbanners/${exhibition.BannerImage}`}/></p> : 
      'HELEXPO: ΦΟΡΜΑ ΣΥΜΜΕΤΟΧΗΣ ΣΕ ΕΚΘΕΣΗ // EXHIBITOR`S REGISTRATION FORM'
    }
      
    </h4>
    </Alert>

    <br/>
    <UserContext.Provider value={{epimelitiria,originalAccountingData,setOriginalAccountingData,tempData,sendForm,showOldProfileModal,setShowOldProfileModal,oldProfiles,setOldProfiles,catalogueData,setCatalogueData,isLoadingContact,setIsLoadingContact,temporarySave,accountingData,setAccountingData,activeTab,setActiveTab,countriesList,countriesListGr,countriesListEng,checkVatNum,oikoi,setOikoi,exhibits,setExhibits,exhibition,setExhibition,exhibitionExhibits,setExhibitionExhibits,items,setItems,loadAllExhibits,exhibitionExhibitsLocal,setExhibitionExhibitsLocal}}>
    <Tabs style={{backgroundColor:'#f0f0f0'}} variant="pills" activeKey={activeTab} className='mb-3'>
      <Tab  eventKey="accounting" title="ΣΤΟΙΧΕΙΑ ΤΙΜΟΛΟΓΗΣΗΣ // ACCOUNTING DETAILS" disabled>
          <AccountingData/>
      </Tab>

      <Tab  eventKey="catalogue" title="ΣΤΟΙΧΕΙΑ ΚΑΤΑΛΟΓΟΥ // CATALOGUE DETAILS" disabled>
          <CatalogueData/>
      </Tab>


      {exhibition.XP==1 &&
      
      <Tab eventKey="b2b" title="ΣΤΟΙΧΕΙΑ ΥΠΕΥΘΥΝΟΥ B2B // B2B CONTACT DETAILS" disabled>
      <B2b/>
      </Tab>     
      
      
      }


      <Tab eventKey="firms" title="ΟΙΚΟΙ // FIRMS" disabled>
        <Firms/>
      </Tab>


      <Tab eventKey="exhibits" title="ΕΚΘΕΜΑΤΑ // EXHIBITS" disabled>
        <Exhibits/>
      </Tab>

      <Tab eventKey="stands" title="ΠΕΡΙΓΡΑΦΕΣ ΧΩΡΩΝ// TYPES OF STANDS" disabled>
      <Items/>
      </Tab>

      <Tab eventKey="finish" title="ΟΛΟΚΛΗΡΩΣΗ ΕΓΓΡΑΦΗΣ // FINISH" disabled>
      <Finish/>
      </Tab>

      <Tab eventKey="thankyou" title="." disabled>
      <Thankyou/>
      </Tab>


    </Tabs>

    </UserContext.Provider>



    <Modal show={!exhibition.GLX_ExCode} onHide={handleClose} backdrop="static">
        <Modal.Header>
        <Modal.Title>
            <table width="100%"><tr><td align="center">
            <img src={logo} width="80%"/><hr/>
            Επιλογή Έκθεσης // Select Exhibition
            </td></tr></table>
        </Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
          <Form.Group className="mb-3">

            <Form.Select onChange={(e)=>getExhibition(e.target.value)}>
              <option value=''>[ΕΠΙΛΟΓΗ ΕΚΘΕΣΗΣ // SELECT EXHIBITION]</option>
              {exhibitionsList}
            </Form.Select>
          </Form.Group>

        </Modal.Body>
    </Modal>


    <Modal size="lg" show={showOldProfileModal} onHide={handleClose1} backdrop="static">
        <Modal.Header>
        <Modal.Title>
            Επιλογή Έκθεσης // Select Exhibition
        </Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
          Θέλετε να χρησιμοποιήσετε τα στοιχεία καταλόγου,οίκους και εκθέματα από προηγούμενή σας συμμετοχή;
          //
          Do you want to use the catalogue details, firms and exhibits from a previous participation?
          <br/><br/>




          <Form.Group className="mb-3">

            <Form.Select onChange={(e)=>getProfile(e.target.value)}>
              <option value=''>[ΕΠΙΛΟΓΗ ΕΚΘΕΣΗΣ // SELECT EXHIBITION]</option>
              {oldProfilesList}
            </Form.Select>
          </Form.Group>

            {tempData.ISTEMP  &&
             <>
             <hr/>
              Είχατε κάνει ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ της φόρμας, θέλετε να ανακτήσετε τα δεδομένα; // You have temporarily saved the form, you want to recover the data?
              <br/><br/>
              <Button variant="warning" onClick={()=>{restoreTempData();setShowOldProfileModal(false)}}>ΕΠΑΝΑΚΤΗΣΗ ΠΡΟΣΩΡΙΝΗΣ ΑΠΟΘΗΚΕΥΣΗΣ // RESTORE TEMPORARY SAVED DATA</Button>
              <hr/>
             </>
             
             } 
            <br/><br/><br/>
        <p align="right">
            <Button variant="secondary" onClick={()=>setShowOldProfileModal(false)}>ΑΚΥΡΟ // CANCEL</Button>
          </p>
        </Modal.Body>
    </Modal>
    
  </Container>  

  )
}
